<form #detachTrailerForm="ngForm">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.detach-trailer',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-string-field name="value" [(ngModel)]="stepperModel.workingData.swapTrailerNumber"
    #ctrlSwapTrailerNumber="ngModel"
    [label]="'swap trailer number' | translate: ['tmc.transport-attach-detach.dialog.label.swapTrailerNumber', translationService.language]"
    [required]="true" [grow]="true"></sc-string-field>
</form>